<template>

	<div class="p-0">

	<Panel header="Inscrições por estado da inscrição"  class="col-12 md:col-12 p-0" :toggleable="false">
		<div class="row grid justify-content-center" v-if="graficoInscricoesPorEstado.labels.length<=0">
			<label>Não há dados</label>
		</div>
		<div v-else>
			<ProgressSpinner v-if="graficoInscricoesPorEstado.loading"/>
			<div v-else class="grid justify-content-center">
				<Chart type="pie" :data="graficoInscricoesPorEstado" style="height:300px"/>

				<DataTable :value="inscricoesPorEstado"
							class="p-datatable-sm p-datatable-gridlines p-datatable-striped" style="width: 25%"
							dataKey="id">

					<Column header="Estado da inscrição" headerStyle="width:50%; text-align: center">
						<template #body="slotProps">
							{{slotProps.data.nome.descricao}}
						</template>
					</Column>

					<Column header="Inscrições">
						<template #body="slotProps">
							{{slotProps.data.totalInscricoes}}
						</template>
					</Column>

				</DataTable>
			</div>
		</div>
	</Panel>

	<div class="grid formgrid ">
		<Panel header="Inscrições candidatos ampla concorrência"  class="col-12 md:col-6" :toggleable="false">

		<ProgressSpinner v-if="graficoCandidatosVagasAmplaConcorrência.loading"/>

		<div v-else>

			<Chart type="bar" :data="graficoCandidatosVagasAmplaConcorrência" />

			<DataTable :value="candidatosVagasAmpla" class="p-datatable-sm p-datatable-gridlines p-datatable-striped p-justify-center justify-content-center"  style="width: 100%">
				<Column header="Área" headerStyle="width:30%">
					<template #body="slotProps">
					<div style="text-align: right">
							{{slotProps.data.area}}
						</div>
					</template>
				</Column>
				<Column header="Vagas ampla concorrência">
					<template #body="slotProps">
						<div style="text-align: right">
							{{slotProps.data.vagas}}
						</div>
					</template>
				</Column>
				<Column header="Inscritos ampla concorrência">
					<template #body="slotProps">
						<div style="text-align: right">
							{{slotProps.data.totalInscricoes}}
						</div>
					</template>
				</Column>
				<Column header="Candidatos/Vagas">
					<template #body="slotProps">
						<div style="text-align: right">
							{{slotProps.data.candidatosVagas ==-1 ? 'N/A': slotProps.data.candidatosVagas }}
						</div>
					</template>
				</Column>
			</DataTable>
		</div>
		</Panel>

		<Panel header="Inscrições candidatos com deficiência"  class="col-12 md:col-6" :toggleable="false">

		<ProgressSpinner v-if="graficoCandidatosVagasDeficientes.loading"/>

		<div v-else class="p-justify-center justify-content-center">

			<Chart type="bar" :data="graficoCandidatosVagasDeficientes"/>

			<DataTable :value="candidatosVagasDeficientes" class="p-datatable-sm p-datatable-gridlines p-datatable-striped p-justify-center justify-content-center" style="width: 100%">

				<Column header="Área" headerStyle="width:30%">
					<template #body="slotProps">
						<div style="text-align: right">
							{{slotProps.data.area}}
						</div>
					</template>
				</Column>

				<Column header="Vagas candidatos com deficiência">
					<template #body="slotProps">
						<div style="text-align: right">
							{{slotProps.data.vagas}}
						</div>
					</template>
				</Column>

				<Column header="Inscritos com deficiência">
					<template #body="slotProps">
						<div style="text-align: right">
							{{slotProps.data.totalInscricoes}}
						</div>
					</template>
				</Column>

				<Column header="Candidatos/Vagas"  >
					<template #body="slotProps">
						<div style="text-align: right">

						{{slotProps.data.candidatosVagas ==-1 ? 'N/A': slotProps.data.candidatosVagas }}
						</div>
					</template>
				</Column>

			</DataTable>
		</div>
		</Panel>

		<Panel header="Inscrições candidatos com Convênio"  class="col-12 md:col-6" :toggleable="false">

		<ProgressSpinner v-if="graficoCandidatosConvenio.loading"/>

		<div v-else class="p-justify-center justify-content-center">

			<Chart type="bar" :data="graficoCandidatosConvenio"/>

			<DataTable :value="candidatosConvenio" class="p-datatable-sm p-datatable-gridlines p-datatable-striped p-justify-center justify-content-center" style="width: 100%">

				<Column header="Instituição" headerStyle="width:30%">
					<template #body="slotProps">
						<div style="text-align: right">
							{{slotProps.data.instituicao ? slotProps.data.instituicao.descricao : "Outros"}}
						</div>
					</template>
				</Column>

				<Column header="Inscritos">
					<template #body="slotProps">
						<div style="text-align: right">
							{{slotProps.data.totalInscricoes}}
						</div>
					</template>
				</Column>

			</DataTable>
		</div>
		</Panel>

	</div>

	</div>
</template>

<script>

import InscricaoService from '../service/InscricaoService';
import EstadoInscricaoService from '../service/EstadoInscricaoService';
import ProgressSpinner from 'primevue/progressspinner';
import Chart from 'primevue/chart';

export default {
	props: ['processo'],
	components: {ProgressSpinner, Chart},

    data() {
        return {
		   //    processo: null,
		   inscricoes: null,
		   inscricoesPorEstado: [],
		   candidatosVagasAmpla: [],
		   candidatosVagasDeficientes: [],
		   candidatosConvenio: [],
		   graficoInscricoesPorEstado: {
			loading: true,
			labels: [],
			datasets: [
			{
				data: [],
					backgroundColor: [
						"#36A2EB",
						"#FFCE56",
						"#008000",
						"#FF6384"
					],
					hoverBackgroundColor: [
						"#36A2EB",
						"#FFCE56",
						"#008000",
						"#FF6384"
					]
			}
			]
		},
		graficoCandidatosVagasAmplaConcorrência: {
			loading: true,
			labels: [],
			datasets: [
				{
					label: 'Inscrições candidatos ampla concorrência',
					backgroundColor: 'rgba(54, 162, 235, 0.2)',
					indexAxis: 'y',
				    borderColor: 'rgb(54, 162, 235)',
    				borderWidth: 1,
					data: []
				}
			]
		},
		graficoCandidatosVagasDeficientes: {
			loading: true,
			labels: [],
			datasets: [
				{
					label: 'Inscrições candidatos com deficiência',
					backgroundColor: 'rgba(255, 159, 64, 0.2)',
					indexAxis: 'y',
					borderWidth: 1,
					borderColor: 'rgb(255, 159, 64)',
					data: []
				}
			]
		},
		graficoCandidatosConvenio: {
			loading: true,
			labels: [],
			datasets: [
				{
					label: 'Inscrições candidatos com Convênio',
					backgroundColor: 'rgba(0, 153, 0, 0.2)',
					indexAxis: 'y',
					borderWidth: 1,
					borderColor: 'rgb(0, 159, 0)',
					data: []
				}
			]
		}
        }
	},

	inscricaoService: null,
	estadoInscricaoService: null,

	created() {
		this.inscricaoService = new InscricaoService();
		this.estadoInscricaoService = new EstadoInscricaoService();
	},

 	mounted() {

		this.atualizarTela();

	},

	watch: {
		processo() {
			this.atualizarTela();
		}
	},

	methods: {
		atualizarTela() {
			this.estadoInscricaoService.getEstadosInscricao().then((data) => {
				this.estados = data
				this.gerarGraficoInscricoesPorEstado();
				this.gerarGraficoCandidatosVagasAmplaConcorrência();
				this.gerarGraficoCandidatosVagasDeficientes();
				this.gerarGraficoCandidatosConvenio();
			});
		},

		gerarGraficoInscricoesPorEstado(){
			this.graficoInscricoesPorEstado.loading = true;
			this.graficoInscricoesPorEstado.labels = [];
			this.graficoInscricoesPorEstado.datasets[0].data = [];
			this.inscricaoService.countTotalInscricoesByEstado(this.processo.id)
			.then(data => {
				this.inscricoesPorEstado = data;
				for(let inscricaoByEstadoCod of this.inscricoesPorEstado ){
					this.graficoInscricoesPorEstado.labels.push(inscricaoByEstadoCod.nome.descricao);
					this.graficoInscricoesPorEstado.datasets[0].data.push(inscricaoByEstadoCod.totalInscricoes);
				}
				this.graficoInscricoesPorEstado.loading = false;
			});
		},

		gerarGraficoCandidatosVagasAmplaConcorrência(){
			this.graficoCandidatosVagasAmplaConcorrência.loading = true;
			this.graficoCandidatosVagasAmplaConcorrência.datasets[0].data = [];
			this.graficoCandidatosVagasAmplaConcorrência.labels = [];
			this.inscricaoService.countAreaAmpla(this.processo.id)
				.then(data => {
					let areasTotalInscricoes = data;
					areasTotalInscricoes = this.ordernar(areasTotalInscricoes);
					for(let areaTotalInscricoes of areasTotalInscricoes){
						this.graficoCandidatosVagasAmplaConcorrência.labels.push(areaTotalInscricoes.nome);
						this.graficoCandidatosVagasAmplaConcorrência.datasets[0].data.push(areaTotalInscricoes.totalInscricoesConfirmadas);
					}
					this.candidatosVagasAmpla = this.criarTabelaVagas(areasTotalInscricoes, false);
					this.graficoCandidatosVagasAmplaConcorrência.loading = false;
				});

		},

		ordernar(countInscricoes){

			return countInscricoes.sort(function (candidatosVagas1, candidatosVagas2) {
                        if (candidatosVagas1.totalInscricoes > candidatosVagas2.totalInscricoes) {
                            return -1;
                        }
                        if (candidatosVagas1.totalInscricoes < candidatosVagas2.totalInscricoes) {
                            return 1;
                        }
                        return 0;
                    });

		},

		criarTabelaVagas(areasTotalInscricoes, deficientes){

			let candidatosVagas = [];

			for(let selecaoEstagioArea of this.processo.selecaoEstagioArea){

					let areaTotalInscricoes = areasTotalInscricoes.find(areaTotalInscricoes => areaTotalInscricoes.nome === selecaoEstagioArea.area.nome);
					let totalInscricoes = areaTotalInscricoes ? areaTotalInscricoes.totalInscricoesConfirmadas : 0;

					let areaCandidatoVaga = {
						area: selecaoEstagioArea.area.nome,
						vagas: deficientes ? selecaoEstagioArea.reservadas : selecaoEstagioArea.vagas,
						totalInscricoes: totalInscricoes,
						candidatosVagas: 0.00
					}
					if(areaCandidatoVaga.vagas !=0 ){
	                    areaCandidatoVaga.candidatosVagas =  (areaCandidatoVaga.totalInscricoes/areaCandidatoVaga.vagas).toFixed(2);

					}else{
						 areaCandidatoVaga.candidatosVagas = -1;

					}




					candidatosVagas.push(areaCandidatoVaga);

				}

			return this.ordernar(candidatosVagas);
		},

		gerarGraficoCandidatosVagasDeficientes(){
			this.graficoCandidatosVagasDeficientes.loading = true;
			this.graficoCandidatosVagasDeficientes.labels = [];
			this.graficoCandidatosVagasDeficientes.datasets[0].data = [];

			this.inscricaoService.countAreaDeficientes(this.processo.id)
				.then(data => {

					let areasTotalInscricoes = data;
					areasTotalInscricoes = this.ordernar(areasTotalInscricoes);
					this.graficoCandidatosVagasDeficientes.datasets[0].data = [];

					for(let areaTotalInscricoes of areasTotalInscricoes){
						this.graficoCandidatosVagasDeficientes.labels.push(areaTotalInscricoes.nome);
						this.graficoCandidatosVagasDeficientes.datasets[0].data.push(areaTotalInscricoes.totalInscricoesConfirmadas);
					}

					this.candidatosVagasDeficientes = this.criarTabelaVagas(areasTotalInscricoes, true);
					this.graficoCandidatosVagasDeficientes.loading = false;
				});

		},

		gerarGraficoCandidatosConvenio(){
			this.graficoCandidatosConvenio.loading = true;
			this.graficoCandidatosConvenio.labels = [];
			this.graficoCandidatosConvenio.datasets[0].data = [];

			this.inscricaoService.countTotalInscricoesByInstituicao(this.processo.id)
				.then(data => {
					// console.log("Resultado:", data);
					// apenas UFAM e UEA
					// let instituicoesConvenio = [0, 1, 2];
					let areasTotalInscricoes = data.filter((area) => {return area.instituicao != null;});
					areasTotalInscricoes = this.ordernar(areasTotalInscricoes);
					this.graficoCandidatosConvenio.datasets[0].data = [];
					for(let areaTotalInscricoes of areasTotalInscricoes){
						// console.log(areaTotalInscricoes);
						this.graficoCandidatosConvenio.labels.push(areaTotalInscricoes.instituicao ? areaTotalInscricoes.instituicao.descricao : "Outros");
						this.graficoCandidatosConvenio.datasets[0].data.push(areaTotalInscricoes.totalInscricoes);
					}

					// this.candidatosConvenio = this.criarTabelaVagas(areasTotalInscricoes, true);
					this.candidatosConvenio = areasTotalInscricoes;
					this.graficoCandidatosConvenio.loading = false;
				});
		}

	}
}
</script>